module.exports = __webpack_public_path__ + "static/gummed-f3c3c00614d836440c8f9023da9252e2.gif";